import { Link } from 'react-router-dom';
import { BasePage } from '@/components/ui/base-page';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
    return (
        <BasePage
            title="Page Not Found"
            description="The page you're looking for doesn't exist or has been moved."
        >
            <div className="container max-w-4xl mx-auto py-16 md:py-24 px-4 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="space-y-8"
                >
                    {/* 404 Text */}
                    <div className="relative">
                        <h1 className="text-9xl font-bold text-gray-200 dark:text-gray-800">404</h1>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <h2 className="text-3xl font-bold text-primary">Page Not Found</h2>
                        </div>
                    </div>

                    <p className="text-lg text-gray-600 dark:text-gray-400 max-w-lg mx-auto">
                        The page you're looking for might have been removed, had its name changed,
                        or is temporarily unavailable.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <Link to="/">
                            <Button className="flex items-center gap-2">
                                <Home size={18} />
                                Return Home
                            </Button>
                        </Link>
                        <Button
                            variant="outline"
                            onClick={() => window.history.back()}
                            className="flex items-center gap-2"
                        >
                            <ArrowLeft size={18} />
                            Go Back
                        </Button>
                    </div>

                    {/* Helpful Links */}
                    <div className="pt-6 border-t border-gray-200 dark:border-gray-800 mt-12">
                        <h3 className="text-lg font-medium mb-4">You might be looking for:</h3>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <Link
                                to="/services"
                                className="p-4 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors"
                            >
                                Services
                            </Link>
                            <Link
                                to="/investment"
                                className="p-4 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors"
                            >
                                Investment
                            </Link>
                            <Link
                                to="/software"
                                className="p-4 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors"
                            >
                                Software
                            </Link>
                            <Link
                                to="/contact"
                                className="p-4 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors"
                            >
                                Contact Us
                            </Link>
                        </div>
                    </div>
                </motion.div>
            </div>
        </BasePage>
    );
} 